import { render, staticRenderFns } from "./Fare.vue?vue&type=template&id=bada2b9c&scoped=true&"
import script from "./Fare.vue?vue&type=script&lang=js&"
export * from "./Fare.vue?vue&type=script&lang=js&"
import style0 from "./Fare.vue?vue&type=style&index=0&id=bada2b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada2b9c",
  null
  
)

export default component.exports